import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import "./i18n";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import reportWebVitals from "./reportWebVitals";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";

import { setupStore } from "./_globalStore/redux/store";
import ThemeProvider from "./_globalStore/themeProvider/ThemeProvider";
import CssBaseline from "@mui/material/CssBaseline";
import App from "./App";
import Spinner from "./containers/Spinner/Spinner";

// import "./index.scss";
import "./styles.css";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallbackPage from "./views/error-fallback-page/ErrorFallbackPage";

import "./number.extensions";

// Recaptcha script injection
const recaptchaScript = document.createElement("script");
recaptchaScript.src = `https://www.google.com/recaptcha/enterprise.js?render=${import.meta.env.VITE_RECAPTCHA_API_KEY}`;
recaptchaScript.async = true;
recaptchaScript.defer = true;
document.head.appendChild(recaptchaScript);

ReactDOM.render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorFallbackPage}>
      <React.Suspense fallback={<Spinner size="4x" />}>
        <Provider store={setupStore()}>
          <ThemeProvider>
            <CssBaseline>
              <App />
            </CssBaseline>
          </ThemeProvider>
        </Provider>
      </React.Suspense>
    </ErrorBoundary>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
